module.exports = __webpack_public_path__ + "img/line-brands-solid.b7867234.svg";